export enum ProductSize {
  Small = 'small',
  Medium = 'medium',
}
